import type { ThemeData } from '../models';

export const freeMysteryGiftTheme: Partial<ThemeData> = {
  collectionBanner: {
    default: {
      desktop: {
        src: `https://cdn.shopify.com/s/files/1/0916/4078/files/Collection_Banner_-_FREE_Mystery_Gift_-_D.png?v=1786585205`,
        height: 450,
        width: 2160,
      },
      mobile: {
        src: `https://cdn.shopify.com/s/files/1/0916/4078/files/Collection_Banner_-_FREE_Mystery_Gift_-_M.png?v=1786585204`,
        height: 450,
        width: 2160,
      },
    },
  },
  collectionBannerHideText: {
    default: true,
  },
  homeHeroBanner: {
    default: {
      bottom: {
        desktop: {
          src: `https://cdn.shopify.com/s/files/1/0916/4078/files/Hero_Banner_-_FREE_Mystery_Gift_-_D.png?v=1786585204`,
          height: 1920,
          width: 2280,
        },
        mobile: {
          src: `https://cdn.shopify.com/s/files/1/0916/4078/files/Hero_Banner_-_FREE_Mystery_Gift_-_M.png?v=1786585203`,
          height: 816,
          width: 1242,
        },
      },
    },
  },
  marqueeData: {
    default: {
      text: `FREE GIFT WITH ANY PURCHASE`,
      to: `/collections/products`,
    },
  },
  freeGiftProduct: {
    default: {
      displaySku: 'FREE_MYSTERY_GIFT',
      buttonText: 'FREE WITH EVERY ORDER',
      buttonTo: '/collections/products',
      buttonOptions: {
        backgroundColor: 'rgba(208, 255, 0, 1)',
        textColor: 'rgba(68, 0, 153, 1)',
      },
    },
  },
  globalProductPill: {
    default: {
      variant: 'custom',
      text: 'FREE MYSTERY GIFT',
      customVariantOptions: {
        backgroundColor: 'rgba(208, 255, 0, 1)',
        textColor: 'rgba(68, 0, 153, 1)',
      },
    },
  },
  globalProductCardBadge: {
    default: {
      position: 'bottom-right',
      media: {
        src: `https://cdn.shopify.com/s/files/1/0916/4078/files/Free_Mystery_Gift_Badge.png?v=1786585204`,
        height: 90,
        width: 120,
      },
    },
  },
  globalProductImageBadge: {
    default: {
      position: 'top-left',
      media: {
        src: `https://cdn.shopify.com/s/files/1/0916/4078/files/Free_Mystery_Gift_Badge.png?v=1786585204`,
        height: 90,
        width: 120,
      },
    },
  },
};
